import { ReactElement } from "react";
import styled from "styled-components";
import { ContentContainer, CookieContentProps } from "./styled";
import SectionContent from "./SectionContent";
import { CookieCategoryProp, ToggleStatesProps } from "../CookieConsent";
import React from "react";

interface CustomizeContentProps {
    active: boolean;

    onToggleChange(key: string): void;

    aboutProvider: string;
    toggleStates: ToggleStatesProps;
    infoProps: CookieCategoryProp[];
    settings: {
        expiry: string;
        type: string;
    };
    info: string;
}

const Wrapper = styled.div<{ active: boolean }>`
  width: 100%;
  max-height: ${({ active }) => (active ? "6000px" : "0px")};
  transition: 2s max-height;
  overflow: hidden;
`;

const Scroll = styled.div``;

const Container = styled.div`
	width: 100%;
	height: calc(100vh - 420px);
	border-top: 1px solid #e0e3dd;
	border-bottom: 1px solid #e0e3dd;
	margin: 32px 0;
	padding: 30px 48px 0 48px;
	overflow: auto;

	&::-webkit-scrollbar {
		width: 0;
	}

	& ${ContentContainer}:not(:last-child) {
		border-bottom: 1px solid #e0e3dd;
	}
	@media screen and (max-width: 500px) {
		padding: 30px 24px;
		width: calc(100% - 48px);
	}
`;

const Info = styled.div`
  margin: 24px 0;
  line-height: 20px;
  font-size: 12px;
  color: #626560;
`;

const CustomizeContent = (props: CustomizeContentProps): ReactElement => {
    return (
        <Wrapper active={props.active}>
            <Scroll>
                <Container>
                    {props.infoProps.map((item) => {
                        return <SectionContent settings={props.settings} aboutProvider={props.aboutProvider} infoProps={item} onToggleChange={props.onToggleChange} toggleState={props.toggleStates[item.id]} key={item.id} />;
                    })}
                    <Info
                        dangerouslySetInnerHTML={{
                            __html: props.info,
                        }}
                    />
                </Container>
            </Scroll>
        </Wrapper>
    );
};

export default CustomizeContent;
